<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <div class="mb-1">
            <b-badge
              style="font-size: 12px"
              :variant="
                formData.expenseStatus === 'Y'
                  ? 'success'
                  : formData.expenseStatus === 'N'
                  ? 'danger'
                  : 'primary'
              "
            >
              {{ formData.v_expenseStatus ? formData.v_expenseStatus : '--' }}
            </b-badge>
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266">
              Update：{{ formData.modifyByName ? formData.modifyByName : '--' }}
              at
              {{ formData.modifyDate ? formData.modifyDate : '--' }}
            </span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_expenseBizType') || '业务类型'"
            prop="expenseBizType"
          >
            <dict-select
              v-model="formData.expenseBizType"
              url="/sys/common/dict/system"
              :body="expenseBizTypeParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="small"
              style="width: 100%"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_expenseName') || '中文名称'"
            prop="expenseName"
          >
            <el-input
              clearable
              v-model="formData.expenseName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_expenseNameEn') || '英文名称'"
          >
            <el-input
              clearable
              v-model="formData.expenseNameEn"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_expenseType') || '费用项目'"
            prop="expenseType"
          >
            <dict-select
              v-model="formData.expenseType"
              url="/master/common/dict/biz"
              :body="expenseTypeParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="small"
              style="width: 100%"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$l('form_label_remark') || '备注说明'">
            <el-input
              clearable
              v-model="formData.remark"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              type="textarea"
              rows="3"
              size="small"
              maxlength="200"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    expenseCode: String,
    params: {type: Object, default: () => {}},
  },
  data() {
    return {
      formData: {},
      rules: {
        expenseName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        expenseBizType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        expenseType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
      },

      expenseBizTypeParams: {dictType: 'expenseBizType'},
      expenseTypeParams: {dictType: 'expenseType'},
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.expenseCode) return

      this.$api
        .masterExpenseDetailApi({
          expenseCode: this.expenseCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .masterExpenseSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
  },
}
</script>
